module.exports = __webpack_public_path__ + "img/icon-speed-6.62202a24.svg";